import { render, staticRenderFns } from "./Megami.vue?vue&type=template&id=9b9db4aa&scoped=true&"
import script from "./Megami.vue?vue&type=script&lang=js&"
export * from "./Megami.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b9db4aa",
  null
  
)

export default component.exports